import { GuestRecipeBoxData } from '../modules/recipes/providers/guest-recipe-box-data';
import { AccountCommon } from '../modules/account/pages/account/account.common';
import { Component, ViewChild, enableProdMode, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { DeepLinker } from 'ionic-angular';
import { Platform, Nav, Events, AlertController } from 'ionic-angular';
import { StatusBar, Splashscreen, InAppBrowser } from 'ionic-native';
import { AppSettings } from '../config/app-settings';
// import { fbConf } from '../config/firebase-config';

import { PageRef } from '../core/core.module';
import { TabsPage } from '../pages/tabs/tabs';
import { EventCodes } from '../core/codes';
import { Navigation } from '../core/navigation';
import { UserData } from '../providers/user-data';
import { Angulartics2Piwik } from "angulartics2";
import { RecipeListPageFull } from '../modules/recipes/pages/recipe-list/recipe-list.full';
import { ShoppingItemsDataGateway } from '../modules/account/providers/shopping-items-data-gateway';
import { Utils } from '../providers/utils';

enableProdMode();

@Component({
  templateUrl: 'app.html'
})
export class SmartApp {
  public appMode = (<any>document.getElementById('appMode')).value;
  public currentUser: any;
  public rootPage;
  public totalSList = 0;
  public sList = [];
  public keyword = '';	
  public userId = '';
  // the root nav is a child of the root app component
  // @ViewChild(Nav) gets a reference to the app's root nav
  @ViewChild('mainNav') nav: Nav;

  constructor(
    public platform: Platform,
    public events: Events,
    public alertController: AlertController,
    public menu: Navigation,
    public settings: AppSettings,
    public location: Location,
    public deeplinker: DeepLinker,
    public cd: ChangeDetectorRef,
    public pageRef: PageRef,
    public userData: UserData,
    public piwik: Angulartics2Piwik,
    public shoppingItemsDataGateway: ShoppingItemsDataGateway,
		public common: AccountCommon,
		public guestRecipeBoxData: GuestRecipeBoxData

  ) {
    this.rootPage = this.pageRef.get('home');
    this.loadCurrentUser();

    menu.load();

    settings.getData().subscribe((settings) => {
      var url = this.location.path(true);
      if (settings.bottomMenu && this.appMode === 'mobile') {
        this.rootPage = TabsPage;
        //this.nav.setRoot(PageRef.get(settings.homePage));
      } else {
        // Comment out to prevent homepage load twice
        // this.nav.setRoot(this.pageRef.get(settings.homePage)); 
      }


      if (url) {
        let d = this.deeplinker;
        setTimeout(() => {
          d.urlChange(url);
          // Call to get footerMenu for Full Web view
          // if (this.appMode !== 'mobile') {
          //   menu.getData('full-bottom').subscribe();
          // }
        }, 200);
      }

      this.cd.detectChanges();
    });

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.styleDefault();
      Splashscreen.hide();
      if (this.platform.is('ios')) {
        StatusBar.hide();
      }
    });
  }

  public loadCurrentUser() {
    let self = this;

    self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        self.userData.getUser().subscribe((user) => {
          self.currentUser = user;
          self.userId = user ? user.uid : '';

          self.cd.detectChanges();
          self.loadSList();
        });
      }
      else {
          self.loadSList();
      }
    });
  }

  ngAfterViewInit() {

    this.listenToEvents();
  }

  public listenToEvents() {
    let self = this;
    this.events.subscribe(EventCodes.APPSETTINGS_LOADING, () => {
    });
    this.events.subscribe(EventCodes.APPSETTINGS_LOADED, (settings) => {
      
      if (settings[0] && settings[0].requireAppUpdate) {
        let alert = self.alertController.create({
          title: 'App Update',
          message: settings[0].appUpdateMessage,
          buttons: [
            {
              text: 'Download',
              handler: () => {
                new InAppBrowser(settings[0].appDownloadURL, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
              }
            }
          ]
        });
        alert.present();
      }
    });

    this.events.subscribe(EventCodes.USER_LOGIN, () => {
      let self = this;
      self.userData.getUser().subscribe((user) => {
        self.currentUser = user;
        self.cd.detectChanges();
      });
    });

    this.events.subscribe(EventCodes.USER_LOGOUT, () => {
      let self = this;
      self.currentUser = null;
    });

    // Sameple custom action in Dynamic Content
    // <a (click)="triggerAction('click', {func: 'openExternalPage', url:'https://www.instagram.com/brunomars/'})">Instagram</a>
    // <a (click)="triggerAction('click', {func: 'openDynamicPage', name:'impact-of-giving'})">Impact of Giving.</a>
    // <a (click)="triggerAction('click', {func: 'openInternalPage', {name:'account', params: {user: currentUser}})">Instagram</a>

    this.events.subscribe(EventCodes.DYNAMIC_CONTENT_ACTION, (items) => {
      if (items && items[0].action == "click") {
        if (items[0].params && items[0].params.func == "openDynamicPage") {
          // self.nav.push(DynamicPage, {name:items[0].params.name});
        } else if (items[0].params && items[0].params.func == "openExternalPage") {
          new InAppBrowser(items[0].params.url, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
        } else if (items[0].params && items[0].params.func == "openInternalPage") {
          this.nav.push(this.pageRef.get(items[0].params.name));
        }
      }
    });
  }

  public openPage(menuItem) {
    switch (menuItem.type) {
      case "inapp":
        this.nav.setRoot(this.pageRef.get(menuItem.link), menuItem.param);
        break;

      case "web":
        new InAppBrowser(menuItem.link, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
        break;

      case "dynamic-page":
        // this.nav.setRoot(DynamicPage, {name: menuItem.link});
        break;

      default:
        // code...
        break;
    }
  }

  //Recipe Page
  public searchRecipe(event) {
    let view = this.nav.getActive();
    if (event.keyCode == 13) {
      if (view.instance instanceof RecipeListPageFull) {
        // view.instance.changPage(1);
        view.instance.searchRecipes(this.keyword);
      }
    }
  }
  public closeSearchBar()
  {
    let view = this.nav.getActive();
    if (view.instance instanceof RecipeListPageFull) {
        // view.instance.changPage(1);
        view.instance.cleanUpKeyword();
      }
  }
  
  //Shopping List popup
  public loadSList(){
    var self = this;
    let slistService = self.shoppingItemsDataGateway.getService(self.userId);

    slistService.get(self.userId).subscribe(shopitems => {
			shopitems = Utils.toAngularFireArray(shopitems).reverse();
      var shopItemData = [];

			_.forEach(shopitems, function (item) {
				if (item.$key != 'timestampCreated') {
					var shopItem = item;
					shopItemData.push(shopItem);
				}
			});

			self.sList = _.sortBy(shopItemData, function(item){
        return item.categoryName;
      });

      self.totalSList = shopItemData.length;
		});
  }
  
	signOut(){
		this.common.signOut(this.nav);
		this.guestRecipeBoxData.cleanData();
	}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts